import { service } from '../../../../helpers/http'

export const ActionIndexVacancyControl = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'indexVacancyControl',
        payload: payload,
    })
}

export const ActionIndexOccupancyDashboard = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'indexOccupancyDashboard',
        payload: payload,
    })
}

export const ActionShowDashboardSettings = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'showDashboardSettings',
        payload: payload,
    })
}

export const ActionShowAmbienceDetail = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'showAmbienceDetail',
        payload: payload,
    })
}
